import template from './adpTint.html';
import controller from './adpTint.controller';
import './adpTint.less';

let adpTintComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default adpTintComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTint/adpTint.component.js